import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(175px, 1fr))',
    gap: theme.other.spacing._8,
  },

  leagueCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.other.spacing._8,
    backgroundColor: theme.white,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    padding: theme.other.spacing._16,
    textDecoration: 'none',
    width: '100%',

    '&.disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },

    '& > svg': {
      stroke: theme.colors.blue[4],
    },

    '@media (hover: hover)': {
      transition: 'opacity 150ms ease-in-out',

      '&:not(:disabled):hover': {
        opacity: 0.5,
      },
    },
  },
}));

export default useStyles;
